import _keyBy from 'lodash/keyBy';


/*
  This functionality is implemented as a quickfix for https://jira.willhillatlas.com/browse/SBKS-2383 issue.
  Even though a better place for it is `make-feature-renderer` package it was decided to place it here because
  it is a tactical solution that should be removed in the very near future.

  This code searches recursively for configuration nodes that match renderers that implement `renderToPortal` method
  and runs `renderToPortal` with the nodes' configurations. Works only one level
  deep (only for nodes that are 'leaves' in configuration tree and have no children) which actualy
  covers our cases - login, registration and deposit.
*/

var makeFeatureRendererInPortal = function makeFeatureRendererInPortal(portalRenderersByType) {
  return function renderToPortal(node) {
    if (!node) return null;

    var type = node.type,
        _node$data = node.data,
        data = _node$data === undefined ? {} : _node$data,
        _node$children = node.children,
        children = _node$children === undefined ? [] : _node$children;

    var renderer = portalRenderersByType[type];

    if (renderer) {
      return renderer.renderToPortal({ type: type, data: data });
    }

    return children.map(function (nodeChild) {
      return renderToPortal(nodeChild);
    }).filter(function (element) {
      return !Array.isArray(element);
    });
  };
};

var getPortalRenderers = function getPortalRenderers(renderers) {
  return renderers.filter(function (renderer) {
    return renderer.renderToPortal;
  });
};

export default (function (renderers) {
  var renderersByType = _keyBy(getPortalRenderers(renderers), 'type');
  return makeFeatureRendererInPortal(renderersByType);
});
//# sourceMappingURL=makeFeatureRendererInPortal.js.map